import { Box, Flex, Text, Link, Icon } from '@chakra-ui/react';
import { Mail } from 'lucide-react';
import { useIsMobile } from '../hooks/useIsMobile';

export default function Footer() {
  const isMobile = useIsMobile();

  return (
	<Box
		width="100%"
		fontFamily={"Montserrat"}
		fontWeight={"500"}
	>
		{/* Blue row */}
		<Flex 
			bg="blue.100" 
			color="white" 
			py={2}
			justifyContent="center" 
			alignItems="center"
		>
			{/* Content */}
			<Flex
				wrap={"wrap"}
				width={{ base: "90%", md: "55%" }}
				justifyContent={{ base: "center", md: "space-around" }}
				gap={4}
			>
				{/* <Flex alignItems="center">
					<Icon as={Phone} mr={2} />
					<Link href="tel:(832)-795-4795">(832)-795-4795</Link>
				</Flex> */}
				<Flex alignItems="center">
					<Icon as={Mail} mr={2} />
					<Link href="mailto:joedavidwells@gmail.com">joedavidwells@gmail.com</Link>
				</Flex>
			</Flex>
		</Flex>

		{/* White row */}
		<Flex
			bg="white"
			py={2}
			pb={isMobile ? 5 : 2}
			justifyContent="center" 
			alignItems="center"
		>
			{/* Content */}
			<Flex
				wrap={"wrap"}
				width={"90%"}
				justifyContent={"center"}
				alignItems={"center"}
			>
				<Link
					href="https://www.johnbajor.dev/"
					target='_blank'
					_hover={{
						textDecoration: 'none',
					}}
				>
					<Text color={"blue.100"}>
						Site by John Bajor
					</Text>
				</Link>
			</Flex>
		</Flex>
	</Box>
  );
}
